import React from "react";
import { Outlet } from "react-router";
import PublicLayout from "../layout/PublicLayout";

const PublicOutlet: React.FC = (): React.ReactElement => {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
};

export default PublicOutlet;
